import React from 'react';
import { View } from '@smarterservices/smarter-ui';
import { BlockComponentProps, StepListBlock as StepListBlockType } from '../../types';
import { StepBlock } from '../StepBlock';

/**
 * StepListBlock component renders a list of steps
 * 
 * @param {BlockComponentProps<StepListBlockType>} props - Component props
 * @returns {React.ReactElement} Rendered step list
 */
export const StepListBlock = ({ block }: BlockComponentProps<StepListBlockType>) => {
  return (
    <View
          as="div"
          margin={block.margin || "none"}
          position="relative"
          padding="small"
          // Reserve space for the icon and line on the left
          style={{ paddingLeft: '50px' }}
        >
      {block.elements.map((step, index) => (
        <StepBlock
          key={index}
          block={step}
          stepNumber={index+1}
          totalSteps={block.elements.length}
        />
      ))}
    </View>
  );
};

export default StepListBlock;
